import React, { lazy, Suspense } from 'react';
import { MapTo, withComponentMappingContext } from '@adobe/aem-react-editable-components';
import { Container } from '@yme/atoms/grid';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withTranslation } from '@yme/services/i18n';
import { INDENT } from '@yme/tokens/sizes';
import { CardSkeleton } from '../components/CardSkeleton';
import { DEFAULT_PRODUCT_CARD__MARGIN_TOP_DESKTOP, DEFAULT_PRODUCT_CARD__MARGIN_TOP_TABLET, DEFAULT_PRODUCT_CARD_MARGIN_TOP_MOBILE, } from '../constants';
import { isProductCardEmpty } from '../helpers';
import { ProductCardWrapperStyled } from '../styled';
const CardUnit = lazy(() => import('./CardUnit'));
const ProductCardEditConfig = {
    emptyLabel: 'Product Card',
    isEmpty: isProductCardEmpty,
};
function CardUnitWrapper(props) {
    return (React.createElement(Suspense, { fallback: React.createElement(Container, null,
            React.createElement(ProductCardWrapperStyled, { topOffset: INDENT.xl, withBackground: true, hasMargin: true },
                React.createElement(CardSkeleton, { mobileMargin: `${DEFAULT_PRODUCT_CARD_MARGIN_TOP_MOBILE}px`, tabletMargin: `${DEFAULT_PRODUCT_CARD__MARGIN_TOP_TABLET}px`, desktopMargin: `${DEFAULT_PRODUCT_CARD__MARGIN_TOP_DESKTOP}px` }))) },
        React.createElement(CardUnit, { ...props })));
}
export default MapTo(AEM_FUNCTIONS.productCard)(withTranslation(withComponentMappingContext(CardUnitWrapper)), ProductCardEditConfig);
